export interface ConfigurationEncode {
  key: string;
  keyLength: number;
  iv: string;
  ivLength: number;
}

export class ConfigurationEncoder {
  async getConfiguration(manifestPath = "/manifest.json") {
    const response = await fetch(manifestPath);
    const dataJson = await response.json();
    return dataJson.configurationEncode as ConfigurationEncode;
  }
}

export const configurationEncoder = new ConfigurationEncoder();
